// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class PaginationButton extends Component {
  #page: number;

  /**
   * Initialization
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setUp();

    const paginateHandler = this.handlePaginate.bind(this);
    this.addEventListener(EventNames.CLICK, paginateHandler);
  }

  /**
   * Setup properties & validate
   */
  setUp(): void {
    if (!this.el.dataset.page) {
      throw new Error('Page data is required');
    }
    this.#page = parseInt(this.el.dataset.page);
  }

  /**
   * Executes when the user paginates
   */
  handlePaginate(e: Event): void {
    e.preventDefault();
    this.notify(Notifications.PAGINATE, { page: this.#page });
  }
}
